export function favoriteProviderId(record = {}) {
  const id = String(record.providerId || record.providerUid || "").trim();
  return id && id.length <= 128 && !id.includes("/") ? id : "";
}

export function favoriteProviderAvailable(provider, now = Date.now()) {
  if (!provider) return false;
  const status = String(provider.subscriptionStatus || "").toLowerCase();
  const account = String(provider.accountStatus || "").toLowerCase();
  if ([status, account, String(provider.verificationStatus || "").toLowerCase()]
    .some((value) => value === "rejected" || value === "suspended")) return false;
  if (provider.payoutStatus === "blocked") return false;
  if (provider.subscriptionEnd) {
    const end = typeof provider.subscriptionEnd.toMillis === "function"
      ? provider.subscriptionEnd.toMillis() : new Date(provider.subscriptionEnd).getTime();
    if (!Number.isFinite(end) || end <= now) return false;
  }
  return status === "approved" || status === "active" || account === "active";
}

export function activeFavoriteMenu(items, providerId) {
  return items.filter((item) => favoriteProviderId(item) === providerId && item.isActive !== false);
}

export const FAVORITES_TEXT = {
  en: {
    tab: "Favorite Providers", intro: "Save providers from meal cards or past orders, then open their menus here.",
    save: "Save Provider", remove: "Remove Favorite", view: "View Menu", back: "Back to Favorite Providers",
    loading: "Loading favorites...", empty: "No favorite providers yet. Save one from Search Meals or My Orders.",
    unavailable: "This provider is currently unavailable.", noMenu: "No active menu items from this provider.",
    menuLoading: "Loading this provider's menu...", error: "Favorites could not be loaded. Please retry.",
    retry: "Retry", saved: "Provider added to favorites.", removed: "Provider removed from favorites.",
    saveError: "Could not update favorites. Please try again.", login: "Please log in as a client to use favorites.",
    cached: "Offline or cached favorites. Changes require a connection.", live: "Favorites saved to your account.",
    providerError: "Provider details could not be loaded.", menuError: "The menu could not be loaded. Please retry."
  },
  es: {
    tab: "Proveedores favoritos", intro: "Guarda proveedores desde platos o pedidos anteriores y abre sus menús aquí.",
    save: "Guardar proveedor", remove: "Quitar favorito", view: "Ver menú", back: "Volver a favoritos",
    loading: "Cargando favoritos...", empty: "Aún no tienes favoritos. Guarda uno desde la búsqueda o tus pedidos.",
    unavailable: "Este proveedor no está disponible.", noMenu: "Este proveedor no tiene platos activos.",
    menuLoading: "Cargando menú...", error: "No se pudieron cargar los favoritos. Inténtalo de nuevo.",
    retry: "Reintentar", saved: "Proveedor guardado.", removed: "Favorito eliminado.",
    saveError: "No se pudieron actualizar los favoritos.", login: "Inicia sesión como cliente para usar favoritos.",
    cached: "Favoritos guardados en caché. Los cambios requieren conexión.", live: "Favoritos guardados en tu cuenta.",
    providerError: "No se pudieron cargar los datos del proveedor.", menuError: "No se pudo cargar el menú. Reintenta."
  },
  fr: {
    tab: "Prestataires favoris", intro: "Enregistrez des prestataires depuis les plats ou vos commandes et ouvrez leurs menus ici.",
    save: "Ajouter aux favoris", remove: "Retirer le favori", view: "Voir le menu", back: "Retour aux favoris",
    loading: "Chargement des favoris...", empty: "Aucun favori. Ajoutez-en depuis la recherche ou vos commandes.",
    unavailable: "Ce prestataire est indisponible.", noMenu: "Aucun plat actif pour ce prestataire.",
    menuLoading: "Chargement du menu...", error: "Impossible de charger les favoris. Réessayez.",
    retry: "Réessayer", saved: "Prestataire ajouté.", removed: "Favori retiré.",
    saveError: "Impossible de modifier les favoris.", login: "Connectez-vous comme client pour utiliser les favoris.",
    cached: "Favoris en cache. Une connexion est nécessaire pour les modifier.", live: "Favoris enregistrés dans votre compte.",
    providerError: "Impossible de charger les informations du prestataire.", menuError: "Impossible de charger le menu. Réessayez."
  },
  de: {
    tab: "Lieblingsanbieter", intro: "Speichere Anbieter aus Mahlzeiten oder Bestellungen und öffne hier ihre Menüs.",
    save: "Anbieter speichern", remove: "Favorit entfernen", view: "Menü ansehen", back: "Zurück zu Favoriten",
    loading: "Favoriten werden geladen...", empty: "Noch keine Favoriten. Speichere Anbieter aus der Suche oder deinen Bestellungen.",
    unavailable: "Dieser Anbieter ist derzeit nicht verfügbar.", noMenu: "Keine aktiven Menüpunkte bei diesem Anbieter.",
    menuLoading: "Menü wird geladen...", error: "Favoriten konnten nicht geladen werden. Bitte erneut versuchen.",
    retry: "Erneut versuchen", saved: "Anbieter gespeichert.", removed: "Favorit entfernt.",
    saveError: "Favoriten konnten nicht aktualisiert werden.", login: "Bitte als Kunde anmelden.",
    cached: "Gespeicherte Favoriten. Änderungen benötigen eine Verbindung.", live: "Favoriten im Konto gespeichert.",
    providerError: "Anbieterinformationen konnten nicht geladen werden.", menuError: "Menü konnte nicht geladen werden. Erneut versuchen."
  },
  pt: {
    tab: "Fornecedores favoritos", intro: "Salve fornecedores nos pratos ou pedidos anteriores e abra os menus aqui.",
    save: "Salvar fornecedor", remove: "Remover favorito", view: "Ver menu", back: "Voltar aos favoritos",
    loading: "Carregando favoritos...", empty: "Nenhum favorito. Salve um na busca ou nos seus pedidos.",
    unavailable: "Este fornecedor está indisponível.", noMenu: "Este fornecedor não tem itens ativos.",
    menuLoading: "Carregando menu...", error: "Não foi possível carregar favoritos. Tente novamente.",
    retry: "Tentar novamente", saved: "Fornecedor salvo.", removed: "Favorito removido.",
    saveError: "Não foi possível atualizar favoritos.", login: "Entre como cliente para usar favoritos.",
    cached: "Favoritos em cache. Alterações exigem conexão.", live: "Favoritos salvos na sua conta.",
    providerError: "Não foi possível carregar os dados do fornecedor.", menuError: "Não foi possível carregar o menu. Tente novamente."
  }
};
